import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="15" height="9" fill="none"><path d="M14.016.707l-6.5 6.5-6.6-6.5" stroke="currentcolor" stroke-linecap="square"/></svg>`;

export { symbol as default };
